import { animationTransition } from '@shared/utils/animationTransition';
import { styled, Box, StyleSystemProps, keyframes } from '@withjoy/joykit';
import { CSSObject } from '@withjoy/joykit/components/Box/Box.types';

export const appleLightBreathing = keyframes`
  0%, 100% {
    box-shadow: 
      0px 0px 8px 0px rgba(86, 0, 242, 0.04),
      0px 0px 30px 0px rgba(86, 0, 242, 0.04),
      0px 0px 18px -8px rgba(86, 0, 242, 0.08),
      0px 0px 8px 0px color(display-p3 0.3373 0 0.95 / 0.04),
      0px 0px 30px 0px color(display-p3 0.3373 0 0.95 / 0.04),
      0px 0px 18px -8px color(display-p3 0.3373 0 0.95 / 0.08);
  }

  25% {
    box-shadow: 
      0px 0px 12px 0px rgba(86, 0, 242, 0.06),
      0px 0px 40px 0px rgba(86, 0, 242, 0.06),
      0px 0px 24px -10px rgba(86, 0, 242, 0.12),
      0px 0px 12px 0px color(display-p3 0.3373 0 0.95 / 0.06),
      0px 0px 40px 0px color(display-p3 0.3373 0 0.95 / 0.06),
      0px 0px 24px -10px color(display-p3 0.3373 0 0.95 / 0.12);
  }

  50% {
    box-shadow: 
      0px 0px 16px 0px rgba(86, 0, 242, 0.08),
      0px 0px 60px 0px rgba(86, 0, 242, 0.08),
      0px 0px 36px -15px rgba(86, 0, 242, 0.16),
      0px 0px 16px 0px color(display-p3 0.3373 0 0.95 / 0.08),
      0px 0px 60px 0px color(display-p3 0.3373 0 0.95 / 0.08),
      0px 0px 36px -15px color(display-p3 0.3373 0 0.95 / 0.16);
  }

  75% {
    box-shadow: 
      0px 0px 12px 0px rgba(86, 0, 242, 0.06),
      0px 0px 40px 0px rgba(86, 0, 242, 0.06),
      0px 0px 24px -10px rgba(86, 0, 242, 0.12),
      0px 0px 12px 0px color(display-p3 0.3373 0 0.95 / 0.06),
      0px 0px 40px 0px color(display-p3 0.3373 0 0.95 / 0.06),
      0px 0px 24px -10px color(display-p3 0.3373 0 0.95 / 0.12);
  }
`;

export const StyledSearchInputBarRoot = styled(Box)``;
export const StyledInput = styled(Box)`
  &:focus {
    animation: ${appleLightBreathing} 6s ease-in-out infinite;
  }
`;
export const StyledEndEnhancementContainer = styled(Box)``;

const rootStyles: StyleSystemProps = {
  display: 'flex',
  position: 'relative',
  width: '100%',
};

export const iconButtonOverrides = {
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  backgroundSize: '200% 200%',
  backgroundColor: 'color(display-p3 0.337255 0 0.95)',
  backgroundImage: 'radial-gradient(circle at var(--mouse-x, 0%) var(--mouse-y, 50%), color(display-p3 0.286275 0.317647 0.937255) 0%, color(display-p3 0.337255 0 0.95) 100%)',
  backgroundPosition: '0% 50%',
  color: 'white',

  _hover: {
    color: 'white',
    backgroundSize: '100% 100%',
  },
  _active: {
    color: 'white',
    transform: 'scale(0.96)',
    transition: 'transform 0.2s ease-in-out',
  },
};

const inputStyles: CSSObject = {
  height: [8, null, 9],
  width: '100%',
  outline: 'transparent solid 2px',
  backgroundColor: 'white',
  borderRadius: 'full',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'mono5',
  boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.03), 0px 10px 60px -20px rgba(44, 41, 37, 0.03), 0px 9px 36px -30px rgba(0, 0, 0, 0.04)',
  paddingLeft: [8, null, 6],
  paddingRight: '86px',
  typographyVariant: 'body1',
  fontSize: '1rem', // needed to prevent mobile safari from zooming on input focus
  transition: animationTransition('border-color'),
  transitionDelay: '0.2s',
  _hover: {
    borderColor: 'color(display-p3 0.3059 0.0235 0.949)',
  },
  _focus: {
    borderWidth: '2px',
    borderColor: 'color(display-p3 0.3059 0.0235 0.949)',
  },
  _active: {
    borderWidth: '2px',
    borderColor: 'color(display-p3 0.3059 0.0235 0.949)',
  },
  _placeholder: {
    color: 'typeDisabledDark',
  },
  appearance: 'none',
  '&::-webkit-search-decoration': {
    appearance: 'none',
  },
  '&::-webkit-search-cancel-button': {
    appearance: 'none',
  },
};

const endEnhancementContainerStyles = (end: boolean): StyleSystemProps => ({
  position: 'absolute',
  top: 0,
  [end ? 'right' : 'left']: 3,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
});

export const styles = {
  root: rootStyles,
  input: inputStyles,
  endEnhancementContainer: endEnhancementContainerStyles,
};
